import Dialog from '@mui/material/Dialog';
import { dialogContent, dialogTitle, paperProps } from './AlertModal.sx';
import DialogContent from '@mui/material/DialogContent';
import { Button, DialogActions, Typography } from '@mui/material';
import { closeBtn } from 'app/components/Filter/Filter.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessIcon from 'app/components/Icons/SuccessIcon';
import React, { Dispatch, SetStateAction } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import { grey8 } from 'app/components/ThemeProvider/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import logger from 'app/utils/logger';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  transferMutation?: any;
  getTransfer?: any;
}

const AlertModal = (props: Props) => {
  const { open, close, transferMutation, getTransfer } = props;
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const navigate = useNavigate();

  const handleRedirectConvers = () => {
    // logger.log(`/${lang}/transfer-page?type=payment_conversion`);
    navigate(`${lang}/transfer-page?type=payment_conversion`);
    transferMutation({ businessKey: getTransfer?.business_key, data: { transfer_type: 'payment_conversion' } });
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => close(false)}
    >
      <DialogTitle sx={dialogTitle}>
        <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>Hörmətli müştəri,</Typography>
        {/*<Button*/}
        {/*  color={'tertiary'}*/}
        {/*  onClick={() => {*/}
        {/*    close(false);*/}
        {/*  }}*/}
        {/*  sx={closeBtn}*/}
        {/*>*/}
        {/*  <CloseIcon />*/}
        {/*</Button>*/}
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        <Typography sx={{ color: grey8 }}>
          Konvertasiya əməliyyatı üçün keçid edin, əks halda uyğun valyuta seçimi edin.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-start', pl: '40px', pb: '40px' }}>
        <Button
          onClick={() => {
            handleRedirectConvers();
            close(false);
          }}
        >
          Keçid et
        </Button>
        <Button
          color={'secondary'}
          onClick={() => {
            close(false);
          }}
        >
          Bağla
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertModal;
